import { useState, useEffect } from "react";

export default function Loading() {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 450);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="flex flex-col justify-center items-center py-8">
      <style>{`
        @keyframes circle7124 {
          0% {
            top: 60px;
            height: 5px;
            border-radius: 50px 50px 25px 25px;
            transform: scaleX(1.7);
          }
          40% {
            height: 20px;
            border-radius: 50%;
            transform: scaleX(1);
          }
          100% {
            top: 0%;
          }
        }

        @keyframes shadow046 {
          0% {
            transform: scaleX(1.5);
          }
          40% {
            transform: scaleX(1);
            opacity: .7;
          }
          100% {
            transform: scaleX(.2);
            opacity: .4;
          }
        }

        @keyframes wobble {
          0% {
            transform: translateX(-90%);
          }
          50% {
            transform: translateX(90%);
          }
          100% {
            transform: translateX(-90%);
          }
        }

        @keyframes scrolling {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }

        @keyframes shadow {
          0% {
            background-position: -98% 0;
          }
          100% {
            background-position: 102% 0;
          }
        }
      `}</style>

      <div className="relative w-[200px] h-[60px] z-10">
        <div
          className="absolute w-5 h-5 rounded-full origin-center"
          style={{
            left: "15%",
            top: "60px",
            backgroundColor: "#069494",
            animation: "circle7124 0.5s alternate infinite ease",
          }}
        />
        <div
          className="absolute w-5 h-5 rounded-full origin-center"
          style={{
            left: "45%",
            top: "60px",
            backgroundColor: "#ffce1b",
            animation: "circle7124 0.5s alternate infinite ease",
            animationDelay: "0.2s",
          }}
        />
        <div
          className="absolute w-5 h-5 rounded-full origin-center"
          style={{
            right: "15%",
            top: "60px",
            backgroundColor: "#b7410e",
            animation: "circle7124 0.5s alternate infinite ease",
            animationDelay: "0.3s",
          }}
        />

        <div
          className="absolute w-5 h-1 rounded-full bg-black/40 z-[-1] top-[62px] origin-center blur-sm"
          style={{
            left: "15%",
            animation: "shadow046 0.5s alternate infinite ease",
          }}
        />
        <div
          className="absolute w-5 h-1 rounded-full bg-black/40 z-[-1] top-[62px] origin-center blur-sm"
          style={{
            left: "45%",
            animation: "shadow046 0.5s alternate infinite ease",
            animationDelay: "0.2s",
          }}
        />
        <div
          className="absolute w-5 h-1 rounded-full bg-black/40 z-[-1] top-[62px] origin-center blur-sm"
          style={{
            right: "15%",
            animation: "shadow046 0.5s alternate infinite ease",
            animationDelay: "0.3s",
          }}
        />
      </div>
      <div className="mt-3 text-lg font-extrabold tracking-wide">
        <span className="bg-gradient-to-r from-[#069494] via-[#ffce1b] to-[#b7410e] bg-clip-text text-transparent">
          Loading{".".repeat(dotCount)}
        </span>
      </div>
    </div>
  );
}
